/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable linebreak-style */
/* eslint-disable indent */
import React from "react";
import MaterialTable from "material-table";
import { getCaption } from "src/utils/dictionary";

export default function MyMaterialTable(props) {
  return (
    <MaterialTable
      {...props}
      localization={{
        toolbar: {
          nRowsSelected: getCaption("rows_selected"),
          showColumnsTitle: getCaption("show_columns_title"),
          showColumnsAriaLabel: getCaption("show_columns_title"),
          exportTitle: getCaption("export"),
          exportAriaLabel: getCaption("export"),
          exportName: getCaption("export_csv"),
          searchTooltip: getCaption("search"),
          searchPlaceholder: getCaption("search"),
        },
        pagination: {
          labelDisplayedRows: `{from}-{to} ${getCaption("of")} {count}`,
          labelRowsSelect: getCaption("rows"),
          firstAriaLabel: getCaption("first_page"),
          firstTooltip: getCaption("first_page"),
          previousAriaLabel: getCaption("previous_page"),
          previousTooltip: getCaption("previous_page"),
          nextAriaLabel: getCaption("next_page"),
          nextTooltip: getCaption("next_page"),
          lastAriaLabel: getCaption("last_page"),
          lastTooltip: getCaption("last_page"),
        },
        header: {
          actions: getCaption("actions"),
        },
        grouping: {
          placeholder: getCaption("place_holder"),
          groupedBy: getCaption("grouped_by"),
        },
        body: {
          emptyDataSourceMessage: getCaption("no_records"),
          addTooltip: getCaption("add"),
          deleteTooltip: getCaption("delete"),
          editTooltip: getCaption("edit"),
          filterRow: {
            filterTooltip: getCaption("filter"),
          },
          editRow: {
            deleteText: getCaption("delete_text"),
            cancelTooltip: getCaption("cancel"),
            saveTooltip: getCaption("save"),
          },
        },
      }}
    />
  );
}
